"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BADGE_BORDER = exports.BADGE_ANIMATION = exports.BADGE_MEDIUM = exports.BADGE_SMALL = exports.BADGE_PURPLE = exports.BADGE_GREEN = exports.BADGE_BLUE = exports.BADGE_YELLOW = exports.BADGE_PINK = exports.BADGE_RED = exports.BADGE_TOP_RIGHT = exports.BADGE_TOP_LEFT = exports.BADGE_BUTTON_RIGHT = exports.BADGE_BUTTON_LEFT = exports.BADGE_BODY = exports.BADGE = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BADGE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-badge");
exports.BADGE_BODY = exports.BADGE + '-body';
exports.BADGE_BUTTON_LEFT = exports.BADGE + '-bl';
exports.BADGE_BUTTON_RIGHT = exports.BADGE + '-br';
exports.BADGE_TOP_LEFT = exports.BADGE + '-tl';
exports.BADGE_TOP_RIGHT = exports.BADGE + '-tr';
exports.BADGE_RED = exports.BADGE + '-red';
exports.BADGE_PINK = exports.BADGE + '-pink';
exports.BADGE_YELLOW = exports.BADGE + '-yellow';
exports.BADGE_BLUE = exports.BADGE + '-blue';
exports.BADGE_GREEN = exports.BADGE + '-green';
exports.BADGE_PURPLE = exports.BADGE + '-purple';
exports.BADGE_SMALL = exports.BADGE + '-small';
exports.BADGE_MEDIUM = exports.BADGE + '-medium';
exports.BADGE_ANIMATION = exports.BADGE + '-animation';
exports.BADGE_BORDER = exports.BADGE + '-border';
